import './Tag.scss'

import React from 'react'

/**
 * A tag for attributes like route categories or ground types.
 * @param {Object} props
 * @param {string} props.children
 * @param {"secondary"|"success"|"warning"} [props.variant]
 * @param {string} [props.icon]
 */
const Tag = ({ children, variant, icon }) => {
    let classes = 'tag'
    if (variant) classes += ' tag-' + variant

    return (
        <span className={classes}>
            {icon && <i className={icon + ' i-' + (variant || 'white')} />}
            {children}
        </span>
    )
}

export default Tag
